module.exports = __webpack_public_path__ + "static/media/add_data.1281f623.svg";